import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import Select from 'component/utils/Select'
import { connect } from 'react-redux'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'

class BranchSelectSimple extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    noValueLabel: PropTypes.string,
    classNoValueLabel: PropTypes.string,
    excludeInactive: PropTypes.bool,
  }

  constructor(props) {
    super(props)

    this.state = {
      companies: [],
      companyOptions: [],
      error: null,
      loading: false,
    }
  }

  componentDidMount() {
    const { user, excludeInactive } = this.props

    this.setState({ loading: true })

    if (user) {
      const endpoint = excludeInactive ? `${API_URL.BRANCHES}?excludeInactive=true` : API_URL.BRANCHES
      return new Api(user.dsToken)
        .post(endpoint)
        .then((response) => this.onFetchSuccess(response.data))
        .catch((error) => this.onFetchError(error))
    }
  }

  onFetchSuccess(companies) {
    const regionCompanies = []
    const companyOptions = []

    companies.map((company) => {
      if (regionCompanies[company.idRegion] === undefined) {
        regionCompanies[company.idRegion] = []
        regionCompanies[company.idRegion].idRegion = company.idRegion
        regionCompanies[company.idRegion].dsRegion = company.dsRegion
        regionCompanies[company.idRegion].branches = []
      }
      regionCompanies[company.idRegion].branches.push(company)
    })

    regionCompanies.sort((a, b) => {
      if (a.dsRegion < b.dsRegion) {
        return -1
      }
      if (a.dsRegion > b.dsRegion) {
        return 1
      }
      return 0
    })

    regionCompanies.map((region) => {
      companyOptions.push({
        value: region.idRegion,
        label: region.dsRegion,
        visible: true,
      })
      region.branches.map((branch) => {
        companyOptions.push({
          value: branch.id,
          label: `${branch.id} - ${branch.name}`,
          isBranch: true,
          idRegion: branch.idRegion,
          visible: true,
        })

        return branch
      })

      return region
    })

    this.setState({ companyOptions, companies, loading: false, error: null })
  }

  onFetchError(error) {
    this.setState({ error, loading: false, companies: [] })
  }

  renderOption(option, index) {
    const classForOption = option.isBranch ? 'option-branch' : 'option-region'

    return (
      <option value={option.value} className={classForOption} key={index}>
        {option.label}
      </option>
    )
  }

  render() {
    const { name, value, onChange, noValueLabel, classNoValueLabel } =
      this.props
    const t = this.props.translate
    const { companyOptions, loading } = this.state

    return (
      <Select
        id='idRegion'
        name={name}
        value={value}
        onChange={(event) => onChange(event, companyOptions)}
        className={value === '' ? classNoValueLabel : ''}
      >
        <option value=''>
          {noValueLabel && !loading ? noValueLabel : t('ruptures.loading')}
        </option>

        {companyOptions &&
          companyOptions.length > 0 &&
          companyOptions.map(this.renderOption)}

        <option value='999' className='option-region'>
          0999 - {t('analytics.matrix.name')}
        </option>
      </Select>
    )
  }
}

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
})

/*
 * Connects component to I18next
 */
const BranchSelectSimpleTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(BranchSelectSimple)

/*
 * Exports component connected to redux
 */
export default connect(mapStateToProps)(BranchSelectSimpleTranslated)

/*
 * Exports component only
 */
export { BranchSelectSimple }
